import readRequiredStringEnv from './services/readRequiredStringEnv';

const operatingChain = readRequiredStringEnv(
  process.env.NEXT_PUBLIC_OPERATING_CHAIN,
  'NEXT_PUBLIC_OPERATING_CHAIN'
);
export default operatingChain;
